
  $(function() {
        function scrolling_init() {
            $('.human-vision-tab-with-marquee .marquee-content-item>ul>li').click(function(){
                var abcd = $(this).attr('data-target');
                if(document.querySelector('.vision-sticky-header') != null){
                    var top_height = parseInt(document.querySelector('.vision-sticky-header').offsetHeight);
                    }
                $('html, body').animate({
                    scrollTop: $(abcd).offset().top - top_height
                }, 1000);
            });
        }
        scrolling_init();
  });

    $(function() {
        function scrolling_init() {
            $('.vision-sticky-header-link .scroll-traget').click(function(){
                var data_href = $(this)[0].getAttribute('href');
                if(document.querySelector('.vision-sticky-header') != null){
                    var top_height = parseInt(document.querySelector('.vision-sticky-header').offsetHeight);
                    }
                $('html, body').animate({
                    scrollTop: $(data_href).offset().top - top_height
                }, 1000);
            });
        }
        scrolling_init();
    });

    $(function() {
        function scrolling_init() {
            $('.new-tab-with-marquee .marquee-content-item>ul>li').click(function(){
                var abcd = $(this).attr('data-target');
                $('html, body').animate({
                    scrollTop: $(abcd).offset().top
                }, 1000);
            });
        }
         scrolling_init();
  });